import { render, staticRenderFns } from "./ConsigmentRefundPackages.vue?vue&type=template&id=0fabd483"
import script from "./ConsigmentRefundPackages.vue?vue&type=script&lang=js"
export * from "./ConsigmentRefundPackages.vue?vue&type=script&lang=js"
import style0 from "./ConsigmentRefundPackages.vue?vue&type=style&index=0&id=0fabd483&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports